import React, { forwardRef } from "react";

const Input = forwardRef((props, ref) => {
  const {
    className = "",
    containerClassName = "",
    error,
    fullWidth,
    helperText,
    InputLabelProps,
    inputProps: nativeInputProps = {},
    label,
    margin,
    multiline = false,
    rows = 3,
    required,
    startIcon,
    endIcon,
    variant,
    // compatibilidade com o `inputRef` do TextField do MUI (usado para
    // inserir variáveis na posição do cursor)
    inputRef,
    ...inputProps
  } = props;

  const setRef = (node) => {
    [ref, inputRef].forEach((r) => {
      if (typeof r === "function") r(node);
      else if (r) r.current = node;
    });
  };

  const controlClassName = [
    "peer w-full rounded-lg border border-solid bg-[var(--farmazon-input)] px-3 text-sm text-farmazon-text outline-none transition-colors",
    "placeholder:text-farmazon-text-faint hover:border-slate-400 focus:border-green-600 focus:ring-2 focus:ring-green-600/10",
    error ? "border-red-500 focus:border-red-500 focus:ring-red-500/10" : "border-[var(--farmazon-input-border)]",
    multiline ? "min-h-[96px] py-2.5 resize-y" : "h-10",
    startIcon ? "pl-10" : "",
    endIcon ? "pr-10" : "",
    className,
  ].filter(Boolean).join(" ");

  const showFloatingLabel = inputProps.type === "date" || InputLabelProps?.shrink;
  const sharedProps = {
    ...inputProps,
    ...nativeInputProps,
    "aria-invalid": error ? "true" : undefined,
    className: controlClassName,
    placeholder: showFloatingLabel ? inputProps.placeholder : `${label || ""}${required ? " *" : ""}`,
    ref: setRef,
    required,
  };

  return (
    <div className={`relative w-full ${showFloatingLabel ? "pt-2" : ""} ${containerClassName}`}>
      {showFloatingLabel && label && (
        <label
          htmlFor={inputProps.id || inputProps.name}
          className="absolute left-2 top-0 z-[1] bg-farmazon-surface px-1 text-[11px] leading-4 text-farmazon-text-muted"
        >
          {label}{required ? " *" : ""}
        </label>
      )}
      {startIcon && (
        <span className={`pointer-events-none absolute left-3 ${showFloatingLabel ? "top-7" : "top-5"} flex -translate-y-1/2 items-center text-farmazon-text-muted`}>
          {startIcon}
        </span>
      )}
      {multiline ? <textarea {...sharedProps} rows={rows} /> : <input {...sharedProps} />}
      {endIcon && (
        <span className={`absolute right-3 ${showFloatingLabel ? "top-7" : "top-5"} flex -translate-y-1/2 items-center text-farmazon-text-muted`}>
          {endIcon}
        </span>
      )}
      {helperText && (
        <p className={`mb-0 mt-1 text-xs ${error ? "text-red-600" : "text-farmazon-text-muted"}`}>
          {helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = "Input";

export default Input;
